import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { useNavigate  } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Home from "../../Home";
import Breadcrumb from "../../../components/Breadcrumb";
import Maintenance from "../../Maintenance";
import PersonSidebar from "./PersonSidebar";
import { Modal, Spinner } from "react-bootstrap";
import { fetchPersonDetails } from "../actions";

/*** 
@purpose : Functional component
@Parameter : {props}
**/
function PersonInfo(props) {
  const navigate = useNavigate();
  const [lang] = useTranslation("language");
  const [customerNotFound, setCustomerNotFound] = useState();
  const [maintenance, setMaintenance] = useState(false);
  const [loading, setLoading] = useState(true);
  const [details, setDetails] = useState({});
  const [personId, setPersonId] = useState();
  const [isChange, setIsChange] = useState();
  const routes = [
    {
      name: `${lang("Menu.home")}`,
      path: "/",
    },
    {
      name: `${lang("Menu.personCustomer")}`,
      path: "/personCustomer",
    },
    {
      name: `${lang("PersonMenu.personCustomerDetails")}`,
      path: "",
    },
  ];

  useEffect(() => {
    async function fetchPersonInfo() {
      try {
        document.body.classList.remove("sidebar-open");
        document.body.classList.add("sidebar-close-tablet");
        let id;
        let url = window.location.href;
        id = unescape(url).split("?personId=")[1];
        setPersonId(id);
        await props.fetchPersonDetails(id).then((response) => {
          if (response.data.maintenanceWindowFlag) {
            setMaintenance(true);
          } else {
            if (response.data.success === true) {
              setDetails(response.data.data);
              setIsChange(
                response && response.data && response.data.canRequestAttributeChange
              );
              setLoading(false);
            } else if (
              response.data.success === false &&
              response.data.data.message === "given Request id not found"
            ) {
              setLoading(false);
              setCustomerNotFound(true);
            }
          }
        });
      } catch (error) {
        console.error("Error fetching person details:", error);
        setLoading(false);
        setCustomerNotFound(true);
      }
    }
    
    fetchPersonInfo();
  }, []);

  /*** 
  @purpose : Change route
  @Parameter : {e, page}
  **/
  const changeRoute = (e, page) => {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    navigate(page);
  };

  /*** 
  @purpose : Handle organization details
  @Parameter : {}
  **/
  const handleOrganizationDetails = () => {
    navigate("/organizationInfo");
  };

  const goToPerson = async (personId) => {
    window.scrollTo(0, 0);
    document.body.classList.remove("sidebar-open");
    document.body.classList.add("sidebar-close-tablet");
    navigate(`/personInfo?personId=${personId}`);

    window.location.reload();
    setPersonId(personId);
    await props.fetchPersonDetails(personId).then((response) => {
      if (response.data.success === true) {
        setDetails(response.data.data);
        setIsChange(
          response && response.data && response.data.canRequestAttributeChange
        );
      } else if (
        response.data.success === false &&
        response.data.data.message === "given Request id not found"
      ) {
        setCustomerNotFound(true);
      }
    });
  };

  return (
    <Home>
      {maintenance ? (
        <Maintenance />
      ) : (
        <>
          <Breadcrumb routes={routes} />
          {!customerNotFound && !loading && (
            <>
              <div className="back-to mb-3">
                <a
                  onClick={(e) => {
                    changeRoute(e, "/personCustomer");
                  }}
                  className="btn btn-primary btn-sm"
                >
                  {lang("Buttons.backToInquiry")}
                </a>
              </div>
              <div className="title-withbutton">
                <h2>{lang("PersonMenu.personCustomerDetails")}</h2>
                <div className="title-right">
                  <button
                    onClick={(e) => {
                      changeRoute(
                        e,
                        `/personAttributeChange?personId=${personId}`
                      );
                    }}
                    className="btn btn-primary btn-sm"
                    disabled={!isChange}
                  >
                    {lang("Buttons.requestAttributeChange")}
                  </button>
                </div>
              </div>
              <div className="org-main">
                <PersonSidebar
                  id={
                    details &&
                    details.basicProfile &&
                    /* details.basicProfile.legacyUnifiedCustomerCode  /* SAKAMOTO: AHDD-5861 Ultmarc code change */
                    details.basicProfile.unifiedCustomerCode           /* SAKAMOTO: AHDD-5861 Ultmarc code change */
                  }
                />

                <div className="org-wrapper">
                  <div className="card shadow-card">
                    <div className="card-body">
                      <h4 className="strong mb-2">
                        {details &&
                        details.basicProfile &&
                        /* details.basicProfile.legacyUnifiedCustomerCode    /* SAKAMOTO: AHDD-5861 Ultmarc code change */
                        /*  ? details.basicProfile.legacyUnifiedCustomerCode /* SAKAMOTO: AHDD-5861 Ultmarc code change */
                        details.basicProfile.unifiedCustomerCode             /* SAKAMOTO: AHDD-5861 Ultmarc code change */
                          ? details.basicProfile.unifiedCustomerCode         /* SAKAMOTO: AHDD-5861 Ultmarc code change */
                          : ""}
                      </h4>
                      <p>
                        {details &&
                        details.basicProfile &&
                        details.basicProfile.customerNameLocalKana
                          ? details.basicProfile.customerNameLocalKana
                          : ""}
                      </p>
                      <h3 className="inner-title mb-1">
                        {details &&
                        details.basicProfile &&
                        details.basicProfile.customer_name_local
                          ? details.basicProfile.customer_name_local
                          : ""}
                        {details &&
                          details.satusMaitenanceInfo &&
                          details.satusMaitenanceInfo.ultmarcRecordId &&
                          details.satusMaitenanceInfo
                            .ultmarcModificationType && (
                            <span className="badge badge-primary ml-3">
                              Ultmarc
                            </span>
                          )}
                      </h3>
                    </div>
                  </div>

                  <div className="card shadow-card">
                    <div className="card-header">
                      <h4>{lang("organizationDetails.basicProfile")}</h4>
                    </div>
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group horizon-form2">
                            <div className="custom-3">
                              <label>
                                {lang(
                                  "organizationDetails.unifiedCustomerCode"
                                )}
                              </label>
                            </div>
                            <div className="custom-9">
                              <input
                                type="text"
                                className="form-control"
                                value={
                                  details &&
                                  details.basicProfile &&
                                  details.basicProfile.unifiedCustomerCode
                                    ? details.basicProfile.unifiedCustomerCode
                                    : ""
                                }
                                readOnly
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group horizon-form2">
                            <div className="custom-3">
                              <label>
                                {lang("organizationDetails.customerType")}
                              </label>
                            </div>
                            <div className="custom-9">
                              <input
                                type="text"
                                className="form-control"
                                value={
                                  details &&
                                  details.basicProfile &&
                                  details.basicProfile.customerTypeNameLocal
                                    ? details.basicProfile.customerTypeNameLocal
                                    : ""
                                }
                                readOnly
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group horizon-form2">
                            <div className="custom-3">
                              <label>{lang("PersonMenu.gender")}</label>
                            </div>
                            <div className="custom-9">
                              <input
                                type="text"
                                className="form-control"
                                value={
                                  details &&
                                  details.basicProfile &&
                                  details.basicProfile.gender &&
                                  details.basicProfile.gender.value &&
                                  details.basicProfile.gender.value
                                    ? details.basicProfile.gender.value
                                    : ""
                                }
                                readOnly
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group horizon-form2">
                            <div className="custom-3">
                              <label>
                                {lang("organizationDetails.onDutyType")}
                              </label>
                            </div>
                            <div className="custom-9">
                              <input
                                type="text"
                                className="form-control"
                                value={
                                  details &&
                                  details.basicProfile &&
                                  details.basicProfile.onDutyType &&
                                  details.basicProfile.onDutyType.value
                                    ? details.basicProfile.onDutyType.value
                                    : ""
                                }
                                readOnly
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group horizon-form2">
                            <div className="custom-3">
                              <label>
                                {lang("organizationDetails.doctorAssociation")}
                              </label>
                            </div>
                            <div className="custom-9">
                              <input
                                type="text"
                                className="form-control"
                                value={
                                  details &&
                                  details.basicProfile &&
                                  details.basicProfile.stateProvinceNameLocal
                                    ? details.basicProfile
                                        .stateProvinceNameLocal
                                    : ""
                                }
                                readOnly
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group horizon-form2">
                            <div className="custom-3">
                              <label>
                                {lang("organizationDetails.onDutyStartedYear")}
                              </label>
                            </div>
                            <div className="custom-9">
                              <input
                                type="text"
                                className="form-control"
                                value={
                                  details &&
                                  details.basicProfile &&
                                  details.basicProfile.onDutyStartedYear
                                    ? details.basicProfile.onDutyStartedYear
                                    : ""
                                }
                                readOnly
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group horizon-form2">
                            <div className="custom-3">
                              <label>{lang("PersonMenu.registeredYear")}</label>
                            </div>
                            <div className="custom-9">
                              <input
                                type="text"
                                className="form-control"
                                value={
                                  details &&
                                  details.basicProfile &&
                                  details.basicProfile.registeredYear
                                    ? details.basicProfile.registeredYear
                                    : ""
                                }
                                readOnly
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group horizon-form2">
                            <div className="custom-3">
                              <label>{lang("PersonMenu.graduatedYear")}</label>
                            </div>
                            <div className="custom-9">
                              <input
                                type="text"
                                className="form-control"
                                value={
                                  details &&
                                  details.basicProfile &&
                                  details.basicProfile.graduatedYear
                                    ? details.basicProfile.graduatedYear
                                    : ""
                                }
                                readOnly
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group horizon-form2">
                            <div className="custom-3">
                              <label>
                                {lang("PersonMenu.graduatedUniversity")}
                              </label>
                            </div>
                            <div className="custom-9">
                              <input
                                type="text"
                                className="form-control"
                                value={
                                  details && details.basicProfile
                                    ? details.basicProfile.universityNameLocal
                                    : "" + "  " + details &&
                                      details.basicProfile &&
                                      details.basicProfile.graduatedCollege
                                    ? details.basicProfile.graduatedCollege
                                        .value
                                    : ""
                                }
                                readOnly
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="card shadow-card">
                    <div className="card-header">
                      <h4>{lang("organizationDetails.speciality")}</h4>
                    </div>
                    <div className="card-body">
                      <div className="row">
                        {details &&
                          details.speciality &&
                          details.speciality.map((sp, index) => {
                            return (
                              <div className="col-xl-3 col-md-6" key={index}>
                                <div className="form-group">
                                  <input
                                    type="text"
                                    className="form-control"
                                    value={
                                      sp.medicalSpecialityNameLocal
                                        ? sp.medicalSpecialityNameLocal
                                        : ""
                                    }
                                    readOnly
                                  />
                                </div>
                              </div>
                            );
                          })}
                      </div>
                    </div>
                  </div>

                  <div className="card shadow-card">
                    <div className="card-header">
                      <h4>{lang("personDetails.affiliatedFacilities")}</h4>
                    </div>
                    <div className="card-body">
                      {details &&
                        details.affiliatedFacilities &&
                        details.affiliatedFacilities.map((facility, index) => {
                          return (
                            <div key={index}>
                              <div className="labelwith-button">
                                <label>
                                  <a onClick={handleOrganizationDetails}>
                                    <span
                                      className="color-primary"
                                      onClick={(e) => {
                                        changeRoute(
                                          e,
                                          `/organizationInfo?orgId=${facility.customerAffiliationOrganizationId}`
                                        );
                                      }}
                                      >
                                      {facility.affiliatedOrganizationCustomerUnifiedCustomerCode             /* SAKAMOTO: AHDD-5861 Ultmarc code change */
                                        ? facility.affiliatedOrganizationCustomerUnifiedCustomerCode          /* SAKAMOTO: AHDD-5861 Ultmarc code change */
                                        : ""}
                                    </span>
                                  </a>
                                  {facility.affiliatedOrganizationCustomerCustomerNameLocal
                                    ? facility.affiliatedOrganizationCustomerCustomerNameLocal
                                    : ""}
                                </label>
                                <div className="request-buttons">
                                  <button
                                    onClick={(e) => {
                                      changeRoute(
                                        e,
                                        `/affiliationChange?personId=${personId}&affiliationId=${facility.customerAffiliationId}`
                                      );
                                    }}
                                    className="btn btn-primary btn-sm"
                                    disabled={
                                      !facility.canRequestAttributeChange
                                    }
                                  >
                                    {lang(
                                      "Buttons.requestAffiliationAttributeChange"
                                    )}
                                  </button>
                                  <button
                                    onClick={(e) => {
                                      changeRoute(
                                        e,
                                        `/affiliationRetirement?personId=${personId}&affiliationId=${facility.customerAffiliationId}`
                                      );
                                    }}
                                    className="btn btn-primary btn-sm"
                                    disabled={!facility.canRequestDelete}
                                  >
                                    {lang("Buttons.requestRetirement")}
                                  </button>
                                </div>
                              </div>
                              <div className="row spacing-left">
                                <div className="col-md-6">
                                  <div className="form-group horizon-form2 align-top">
                                    <div className="custom-3">
                                      <label>
                                        {lang(
                                          "organizationDetails.affiliatedDepartment"
                                        )}
                                      </label>
                                    </div>
                                    <div style={{
                                        display: 'flex',
                                        alignItems: 'flex-start',
                                      }} className="custom-9">
                                      <div style={{
                                        width: '100%'
                                      }}>
                                        <input
                                          type="text"
                                          className="form-control"
                                          value={
                                            facility.affiliatedDepartmentNameKana
                                              ? facility.affiliatedDepartmentNameKana
                                              : ""
                                          }
                                          readOnly
                                        />

                                        <input
                                          type="text"
                                          className="form-control"
                                          value={
                                            facility.affiliatedDepartmentName
                                              ? facility.affiliatedDepartmentName
                                              : ""
                                          }
                                          readOnly
                                        />
                                      </div>
                                      <div style={{
                                        marginLeft: '23px',
                                        display: 'flex',
                                        width: '119px',
                                        marginTop: '12px',
                                        marginRight: '-141px',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                      }}>
                                        <label style={{
                                          marginRight: '14px'
                                        }} htmlFor="status1">
                                          {lang("organizationDetails.noDM")}
                                        </label>
                                        <input
                                          type="checkbox"
                                          id="status1"
                                          style={{
                                            marginBottom: '7px'
                                          }}
                                          readOnly
                                          name="status"
                                          checked={facility?.noDmFlag === "1"}
                                          onChange={(e) => { e.preventDefault() }}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-12">
                                  <div className="row">
                                    <div className="col-md-6">
                                      <div className="form-group horizon-form2">
                                        <div className="custom-3">
                                          <label>
                                            {lang(
                                              "organizationDetails.jobTitle"
                                            )}
                                          </label>
                                        </div>
                                        <div className="custom-9">
                                          <input
                                            type="text"
                                            className="form-control"
                                            value={
                                              facility.customerAffiliationJobTitleJobTitleNameLocal
                                                ? facility.customerAffiliationJobTitleJobTitleNameLocal
                                                : ""
                                            }
                                            readOnly
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-md-6">
                                      <div className="form-group horizon-form2">
                                        <div className="custom-3">
                                          <label>
                                            {lang(
                                              "organizationDetails.universityJobTitle"
                                            )}
                                          </label>
                                        </div>
                                        <div className="custom-9">
                                          <input
                                            type="text"
                                            className="form-control"
                                            value={
                                              facility.universityJobTitleJobTtileNameLocal
                                                ? facility.universityJobTitleJobTtileNameLocal
                                                : ""
                                            }
                                            readOnly
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <hr />
                            </div>
                          );
                        })}

                      <div>
                        <button
                          onClick={(e) => {
                            changeRoute(
                              e,
                              `/newAffiliationRequest?personId=${personId}`
                            );
                          }}
                          className="btn btn-primary btn-sm"
                        >
                          {lang("Buttons.requestNewAffiliation")}
                        </button>
                      </div>
                    </div>
                  </div>

                  <div className="card shadow-card">
                    <div className="card-header">
                      <h4>
                        {lang("personDetails.affiliatedFacilitiesHistory")}
                      </h4>
                    </div>
                    <div className="card-body">
                      {details &&
                        details.affiliatedFacilitiesHistory &&
                        details.affiliatedFacilitiesHistory.map((facility, index) => {
                          return (
                            <div key={index}>
                              <div className="labelwith-button">
                                <label className="mb-4">
                                  <a>
                                    <span
                                      className="color-primary"
                                      onClick={(e) => {
                                        changeRoute(
                                          e,
                                          `/organizationInfo?orgId=${facility.customerAffiliationOrganizationId}`
                                        );
                                      }}
                                    >
                                      {facility.historyUnifiedCustomerCode              /* SAKAMOTO: AHDD-5861 Ultmarc code change */
                                        ? facility.historyUnifiedCustomerCode           /* SAKAMOTO: AHDD-5861 Ultmarc code change */
                                        : ""}
                                    </span>
                                    {facility.historyCustomerNameLocal
                                      ? facility.historyCustomerNameLocal
                                      : ""}
                                  </a>
                                </label>
                              </div>
                              <div className="row spacing-left">
                                <div className="col-md-6">
                                  <div className="form-group horizon-form2">
                                    <div className="custom-3">
                                      <label>
                                        {lang(
                                          "organizationDetails.retirementDate"
                                        )}
                                      </label>
                                    </div>
                                    <div className="custom-9">
                                      <input
                                        type="text"
                                        className="form-control"
                                        value={facility.validTo}
                                        readOnly
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div className="clearfix"></div>
                                <div className="col-md-6">
                                  <div className="form-group horizon-form2 align-top">
                                    <div className="custom-3">
                                      <label>
                                        {lang(
                                          "organizationDetails.affiliatedDepartment"
                                        )}
                                      </label>
                                    </div>
                                    <div style={{
                                      display: 'flex',
                                      alignItems: 'flex-start',
                                    }} className="custom-9">
                                      <div style={{
                                        width: '100%'
                                      }}>
                                        <input
                                          type="text"
                                          className="form-control"
                                          value={
                                            facility.historyAffiliatedDepartmentNameKana
                                              ? facility.historyAffiliatedDepartmentNameKana
                                              : ""
                                          }
                                          readOnly
                                        />
                                        <input
                                          type="text"
                                          className="form-control"
                                          value={
                                            facility.historyAffiliatedDepartmentName
                                              ? facility.historyAffiliatedDepartmentName
                                              : ""
                                          }
                                          readOnly
                                        />
                                      </div>
                                      <div style={{
                                        marginLeft: '23px',
                                        display: 'flex',
                                        marginTop: '12px',
                                        width: '119px',
                                        marginRight: '-141px',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                      }}>
                                        <label style={{
                                          marginRight: '14px'
                                        }} htmlFor="status1">
                                          {lang("organizationDetails.noDM")}
                                        </label>
                                        <input
                                          type="checkbox"
                                          id="status1"
                                          readOnly
                                          style={{
                                            marginBottom: '7px'
                                          }}
                                          name="status"
                                          checked={facility?.noDmFlag === "1"}
                                          onChange={(e) => { e.preventDefault() }}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-12">
                                  <div className="row">
                                    <div className="col-md-6">
                                      <div className="form-group horizon-form2">
                                        <div className="custom-3">
                                          <label>
                                            {lang(
                                              "organizationDetails.jobTitle"
                                            )}
                                          </label>
                                        </div>
                                        <div className="custom-9">
                                          <input
                                            type="text"
                                            className="form-control"
                                            value={
                                              facility.historycustomerAffiliationJobTitleName
                                                ? facility.historycustomerAffiliationJobTitleName
                                                : "" +
                                                  "," +
                                                  facility.historyCustomerAffiliationJobTitleJobTitleNameLocal
                                                ? facility.historyCustomerAffiliationJobTitleJobTitleNameLocal
                                                : ""
                                            }
                                            readOnly
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-md-6">
                                      <div className="form-group horizon-form2">
                                        <div className="custom-3">
                                          <label>
                                            {lang(
                                              "organizationDetails.universityJobTitle"
                                            )}
                                          </label>
                                        </div>
                                        <div className="custom-9">
                                          <input
                                            type="text"
                                            className="form-control"
                                            value={
                                              facility.historyUniversityJobTitleJobTtileNameLocal
                                                ? facility.historyUniversityJobTitleJobTtileNameLocal
                                                : ""
                                            }
                                            readOnly
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <hr />
                            </div>
                          );
                        })}
                    </div>
                  </div>

                  <div className="card shadow-card">
                    <div className="card-header">
                      <h4>{lang("organizationDetails.maintenanceInfo")}</h4>
                    </div>
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group horizon-form2">
                            <div className="custom-3">
                              <label>
                                {lang("organizationDetails.duplicatedCustomer")}
                              </label>
                            </div>
                            <div className="custom-9">
                              <div className="cust-link">
                                <a
                                  onClick={() =>
                                    goToPerson(
                                      details.satusMaitenanceInfo
                                        .duplicatedCustomerLegacyUnifiedCustomerCodePerCusId
                                    )
                                  }
                                >
                                  {details &&
                                  details.satusMaitenanceInfo &&
                                  details.satusMaitenanceInfo
                                    /* .duplicatedCustomerLegacyUnifiedCustomerCode     /* SAKAMOTO: AHDD-5861 Ultmarc code change */
                                    .duplicatedCustomerUnifiedCustomerCode              /* SAKAMOTO: AHDD-5861 Ultmarc code change */
                                    ? details.satusMaitenanceInfo
                                    /*    .duplicatedCustomerLegacyUnifiedCustomerCode  /* SAKAMOTO: AHDD-5861 Ultmarc code change */
                                        .duplicatedCustomerUnifiedCustomerCode          /* SAKAMOTO: AHDD-5861 Ultmarc code change */
                                    : ""}
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group horizon-form2">
                            <div className="custom-3">
                              <label>
                                {lang(
                                  "organizationDetails.pharmacistCorrespondenceCode"
                                )}
                              </label>
                            </div>
                            <div className="custom-9">
                              <div className="cust-link">
                                <a
                                  onClick={() =>
                                    goToPerson(
                                      details &&
                                        details.satusMaitenanceInfo
                                          .dentistDuplicatedDoctorRecordLegacyUnifiedCustomerCodePerCusId
                                    )
                                  }
                                >
                                  {details &&
                                  details.satusMaitenanceInfo &&
                                  details.satusMaitenanceInfo
                                   /* .dentistDuplicatedDoctorRecordLegacyUnifiedCustomerCode     /* SAKAMOTO: AHDD-5861 Ultmarc code change */
                                    .dentistDuplicatedDoctorRecordUnifiedCustomerCode             /* SAKAMOTO: AHDD-5861 Ultmarc code change */
                                    ? details.satusMaitenanceInfo
                                   /*     .dentistDuplicatedDoctorRecordLegacyUnifiedCustomerCode /* SAKAMOTO: AHDD-5861 Ultmarc code change */
                                        .dentistDuplicatedDoctorRecordUnifiedCustomerCode         /* SAKAMOTO: AHDD-5861 Ultmarc code change */
                                    : ""}
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group horizon-form2">
                            <div className="custom-3">
                              <label>
                                {lang(
                                  "organizationDetails.ultmarcPlannedDeleteReason"
                                )}
                              </label>
                            </div>
                            <div className="custom-9">
                              <input
                                type="text"
                                className="form-control"
                                value={
                                  details &&
                                  details.satusMaitenanceInfo &&
                                  details.satusMaitenanceInfo
                                    .ultmarcPlannedDeleteReason &&
                                  details.satusMaitenanceInfo
                                    .ultmarcPlannedDeleteReason.value
                                    ? details.satusMaitenanceInfo
                                        .ultmarcPlannedDeleteReason.value
                                    : ""
                                }
                                readOnly
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group horizon-form2">
                            <div className="custom-3">
                              <label>
                                {lang(
                                  "organizationDetails.ultmarcRecordSuspensionType"
                                )}
                              </label>
                            </div>
                            <div className="custom-9">
                              <input
                                type="text"
                                className="form-control"
                                value={
                                  details &&
                                  details.satusMaitenanceInfo &&
                                  details.satusMaitenanceInfo
                                    .ultmarcRecordSupspensionType &&
                                  details.satusMaitenanceInfo
                                    .ultmarcRecordSupspensionType.value
                                    ? details.satusMaitenanceInfo
                                        .ultmarcRecordSupspensionType.value
                                    : ""
                                }
                                readOnly
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group horizon-form2">
                            <div className="custom-3">
                              <label>
                                {lang(
                                  "organizationDetails.ultmarcRecordSuspensionStartDate"
                                )}
                              </label>
                            </div>
                            <div className="custom-9">
                              <input
                                type="text"
                                className="form-control"
                                value={
                                  details &&
                                  details.satusMaitenanceInfo &&
                                  details.satusMaitenanceInfo
                                    .ultmarcRecordSupspensionStartDate
                                    ? details.satusMaitenanceInfo
                                        .ultmarcRecordSupspensionStartDate
                                    : ""
                                }
                                readOnly
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group horizon-form2">
                            <div className="custom-3">
                              <label>
                                {lang(
                                  "organizationDetails.ultmarcRecordSuspensionEndDate"
                                )}
                              </label>
                            </div>
                            <div className="custom-9">
                              <input
                                type="text"
                                className="form-control"
                                value={
                                  details &&
                                  details.satusMaitenanceInfo &&
                                  details.satusMaitenanceInfo
                                    .ultmarcRecordSupspensionEndDate
                                    ? details.satusMaitenanceInfo
                                        .ultmarcRecordSupspensionEndDate
                                    : ""
                                }
                                readOnly
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group horizon-form2">
                            <div className="custom-3">
                              <label>
                                {lang(
                                  "organizationDetails.ultmarcProcessedDate"
                                )}
                              </label>
                            </div>
                            <div className="custom-9">
                              <input
                                type="text"
                                className="form-control"
                                value={
                                  details &&
                                  details.satusMaitenanceInfo &&
                                  details.satusMaitenanceInfo
                                    .ultmarcProcessedDate
                                    ? details.satusMaitenanceInfo
                                        .ultmarcProcessedDate
                                    : ""
                                }
                                readOnly
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group horizon-form2">
                            <div className="custom-3">
                              <label>
                                {lang(
                                  "organizationDetails.ultmarcModificationType"
                                )}
                              </label>
                            </div>
                            <div className="custom-9">
                              <input
                                type="text"
                                className="form-control"
                                value={
                                  details &&
                                  details.satusMaitenanceInfo &&
                                  details.satusMaitenanceInfo
                                    .ultmarcModificationType
                                    ? details.satusMaitenanceInfo
                                        .ultmarcModificationType
                                    : ""
                                }
                                readOnly
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
          {loading && <Spinner animation="border" />}
          <Modal
            size="md"
            className="withdraw-modal"
            show={customerNotFound}
            aria-labelledby="contained-modal-title-vcenter"
            centered
          >
            <Modal.Body>
              <div className="warning-msg">
                <img src="images/warning2.svg" alt="Warning" />
                {lang("errorMessages.CUSTOMER_NOT_FOUND")}
              </div>
              <p className="mb-3">
                {lang("errorMessages.SEARCH_REQUESTS")}
                <a
                  className="link"
                  onClick={(e) => {
                    changeRoute(e, "/personCustomer");
                  }}
                >
                  {lang("Menu.personCustomer")}
                </a>
              </p>
            </Modal.Body>
          </Modal>
        </>
      )}
    </Home>
  );
}

const mapStateToProps = (state) => {
  return {
    details: state.organizationCustomer.orgDetails,
  };
};

export default connect(mapStateToProps, { fetchPersonDetails })(PersonInfo);
